module.exports = __webpack_public_path__ + "static/images/logo_althash_health.4545a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_althash_health.png
// module id = lXzv
// module chunks = 1